import { GetRemoteIPAddress, GetRandomGuid } from "@/api/check/index.js";

const state = {

}

const getters = {

}

const mutations = {

}

const actions = {
    //
    GetRemoteIPAddress(context, payload) {
        return new Promise((resolve, reject) => {
            GetRemoteIPAddress({ ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    //
    GetRandomGuid(context, payload) {
        return new Promise((resolve, reject) => {
            GetRandomGuid({ ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}